module.exports = __webpack_public_path__ + "assets/img/case-en.11101407.webp";